<template>
  <div class="order-details-page">
    <app-header :title="i18n.order_details"></app-header>
    <div class="order-details">
      <!-- 状态行：状态文字 + 橙色刷新按钮 -->
      <div class="order-details-status-row">
        <span class="order-details-status" :class="statusClass">{{
          statusText
        }}</span>
        <i class="order-details-refresh" @click="getOrderDetails"></i>
      </div>

      <!-- 卡片 1：使用时间/总金额 + 租借条款 + 动态按钮 -->
      <div class="order-details-card">
        <div class="order-details-card-row">
          <div class="order-details-card-cell">
            <div class="order-details-card-value">{{ orderDuration() }}</div>
            <div class="order-details-card-label">{{ i18n.order_use_time }}</div>
          </div>
          <div class="order-details-card-cell order-details-card-cell--right">
            <div class="order-details-card-value">
              {{ orderDetails.pcurrencyName
              }}{{ (orderDetails.pJiesuan || 0).toFixed(2) }}
            </div>
            <div class="order-details-card-label">{{ i18n.order_amount }}</div>
          </div>
        </div>
        <div class="order-details-card-divider"></div>
        <div class="order-details-card-label order-details-card-label--full">
          {{ i18n.borrow_standard }}
        </div>
        <div class="order-details-card-rate">{{ feeRatesText }}</div>
        <!-- 动态按钮：未付清红色 Pay / 状态 4 描边按钮 / 其他无 -->
        <div
          v-if="isUnpaid"
          class="order-details-btn order-details-btn--pay"
          @click="orderPayment"
        >
          {{ i18n.order_pay }}
        </div>
        <div
          v-else-if="orderDetails.pZujie === 4"
          class="order-details-btn order-details-btn--outline"
          @click="goHelp"
        >
          {{ i18n.powerbank_not_popup }}
        </div>
      </div>

      <!-- 卡片 2：订单信息 -->
      <div class="order-details-card">
        <div class="order-details-info-head">
          <div class="order-details-info-no">
            {{ i18n.order_number + orderDetails.porderid }}
          </div>
          <div class="order-details-copy" @click="onCopy">
            <svg
              class="order-details-copy-icon"
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              aria-hidden="true"
            >
              <path
                fill="currentColor"
                d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
              />
            </svg>
            <span class="order-details-copy-text">{{ i18n.order_copy }}</span>
          </div>
        </div>
        <div class="order-details-card-divider"></div>
        <div class="order-details-info-row">
          <span class="order-details-info-label">{{ i18n.order_zj_shop }}</span>
          <span class="order-details-info-value">{{
            orderDetails.pshopName || "-"
          }}</span>
        </div>
        <div class="order-details-info-row">
          <span class="order-details-info-label">{{ i18n.order_zj_time }}</span>
          <span class="order-details-info-value">{{
            orderDetails.pborrowtime | dateFmt
          }}</span>
        </div>
        <div class="order-details-info-row">
          <span class="order-details-info-label">{{ i18n.order_gh_shop }}</span>
          <span class="order-details-info-value">{{
            orderDetails.pghShopName || "-"
          }}</span>
        </div>
        <div class="order-details-info-row">
          <span class="order-details-info-label">{{ i18n.order_gh_time }}</span>
          <span class="order-details-info-value">{{
            orderDetails.pghtime | dateFmt
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { ORDER_DETAILS } from "../../apis/user"
import AppHeader from "../../components/common/AppHeader.vue"
export default {
  components: { AppHeader },
  computed: {
    i18n() {
      return this.$t("order")
    },
    // 状态文案：unpaid / status=4 / renting / 其他（与 App 端 _orderStatus 对齐）
    statusText() {
      if (this.isUnpaid) return this.i18n.unpaid // "Unpaid" / "未付款"
      if (this.orderDetails.pZujie === 4) return this.i18n.powerbank_not_popup
      const statusList = [
        this.i18n.not_on_rent,
        this.i18n.renting,
        this.i18n.undone,
        this.i18n.returned,
        this.i18n.questions,
        this.i18n.timeout_to_return,
        this.i18n.suspended_for_billing
      ]
      return statusList[this.orderDetails.pZujie] || ""
    },
    statusClass() {
      if (this.isUnpaid) return "is-unpaid"
      if (this.orderDetails.pZujie === 4) return "is-unpaid"
      if (this.orderDetails.pZujie === 1) return "is-renting"
      return ""
    },
    // 是否未付清：与 item.vue 判断一致
    isUnpaid() {
      return (
        (this.orderDetails.pZujie === 3 ||
          this.orderDetails.pZujie === 5) &&
        Number(this.orderDetails.settledAmount || 0) <
          Number(this.orderDetails.pJiesuan || 0)
      )
    },
    // RENTAL TERMS 文本（fee_rates 模板字符串）
    feeRatesText() {
      const o = this.orderDetails
      const tpl = this.i18n.fee_rates
      if (!tpl) return ""
      // 模板里 {pCurrency} 出现两次，必须用 split/join 全量替换
      return tpl
        .split("{pCurrency}")
        .join(o.pcurrencyName || "")
        .split("{pJifei}")
        .join(Number(o.pjifei || 0).toFixed(2))
        .split("{pJifeiDanwei}")
        .join(o.pjifeiDanwei || "60")
        .split("{pUnit}")
        .join(this.feeUnit)
        .split("{pFengding}")
        .join(Number(o.pfengding || 0).toFixed(2))
    },
    // 计价单位 priceUnit 0-分钟 1-小时 2-天（与 home.vue / shopItem.vue 一致）
    feeUnit() {
      const u = Number(this.orderDetails.priceUnit)
      if (u === 1) return this.$t("home.hour")
      if (u === 2) return this.$t("home.days")
      return this.$t("home.minute")
    }
  },
  data() {
    return {
      orderDetails: {
        pZujie: 0,
        pborrowtime: 0,
        porderid: "",
        pshopName: "-",
        pghShopName: "-"
      }
    }
  },
  methods: {
    // 订单支付
    orderPayment() {
      const order = this.orderDetails
      this.$router.push({
        path: "/confirm",
        query: {
          price: order.pJiesuan,
          payType: "FK",
          outTradeNo: order.porderid,
          cabinetID: order.pCabinetid
        }
      })
    },
    // 状态 4：跳帮助中心
    goHelp() {
      this.$router.push("/help")
    },
    // 复制订单号
    onCopy() {
      const no = this.orderDetails.porderid || ""
      if (!no) return
      // 优先用 Clipboard API；降级走 textarea
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(no)
          .then(() => this.$toast(this.i18n.order_copy_success))
          .catch(() => this.fallbackCopy(no))
      } else {
        this.fallbackCopy(no)
      }
    },
    fallbackCopy(text) {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.left = "-9999px"
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand("copy")
        this.$toast(this.i18n.order_copy_success)
      } catch (e) {
        console.warn("copy failed", e)
      }
      document.body.removeChild(ta)
    },
    // 格式化时间 hh:mm:ss
    orderDateFmt(seconds = 0) {
      let hours = Number.parseInt(seconds / 3600)
      let minutes = Number.parseInt((seconds - hours * 3600) / 60)
      let second = Number.parseInt(seconds - hours * 3600 - minutes * 60)
      second = second < 10 ? "0" + second : second
      hours = hours < 10 ? "0" + hours : hours
      minutes = minutes < 10 ? "0" + minutes : minutes
      return `${hours}:${minutes}:${second}`
    },
    // 订单时长（renting 状态实时计算）
    // pborrowtime 为 UTC 时间字符串：按本地解析后补回时区偏移再取时间戳，与当前时间戳直接作差
    // （口径与 main.js dateFmt filter 一致），不再依赖 $dateFmt 两次“同错抵消”，也避免 iOS 下解析为 NaN
    orderDuration() {
      const order = this.orderDetails
      let seconds = order.puseMins * 60
      if (order.pZujie === 1) {
        const bT = dayjs(order.pborrowtime)
          .add(dayjs().utcOffset() / 60, "hour")
          .valueOf()
        seconds = parseInt((Date.now() - bT) / 1000)
      }
      return this.orderDateFmt(seconds || 0)
    },
    async getOrderDetails() {
      try {
        const { orderId } = this.$route.params
        this.$loading(true)
        const result = await this.$Request("get", ORDER_DETAILS, { orderId })
        if (result && result.code === 0) {
          this.orderDetails = result.data || {}
        }
        this.$loading(false)
      } catch (err) {
        this.$loading(false)
        this.$toast(err)
        console.warn("~ err:", err)
      }
    }
  },
  created() {},
  mounted() {
    this.getOrderDetails()
  }
}
</script>

<style lang="less" scoped>
.order-details-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: var(--page-bg, #f5f5f5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.order-details {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 32px 0;
  box-sizing: border-box;
}

// 状态行：与卡片 1 左对齐（margin: 0 32px）
.order-details-status-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 32px 36px;
}
.order-details-status {
  font-size: 38px;
  font-weight: bold;
  color: var(--text-gray, #999);
  &.is-unpaid {
    color: var(--error-color, #ff0000);
  }
  &.is-renting {
    color: var(--theme-color, #ff8800);
  }
}
.order-details-refresh {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-left: 16px;
  background-color: var(--theme-color, #ff8800);
  -webkit-mask: url(../../assets/imgs/icon_swap@2x.png) no-repeat center /
    contain;
  mask: url(../../assets/imgs/icon_swap@2x.png) no-repeat center / contain;
}

// 卡片（公用）
.order-details-card {
  margin: 0 32px 32px;
  padding: 32px 28px;
  background: #f5f5f8;
  border: 1px solid #e8e8ee;
  border-radius: 18px;
  box-sizing: border-box;
}
.order-details-card-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.order-details-card-cell {
  flex: 1;
  &--right {
    text-align: right;
  }
}
.order-details-card-value {
  font-size: 38px;
  font-weight: bold;
  color: #111;
}
.order-details-card-label {
  margin-top: 8px;
  font-size: 24px;
  font-weight: bold;
  color: #111;
  &--full {
    width: 100%;
    margin-top: 32px;
  }
}
.order-details-card-divider {
  margin: 24px 0;
  height: 1px;
  background-color: #e0e0e0;
}
.order-details-card-rate {
  margin-top: 28px;
  font-size: 28px;
  font-weight: bold;
  color: var(--theme-color, #ff8800);
  text-align: center;
}

// 卡片内动态按钮
.order-details-btn {
  margin-top: 36px;
  height: 80px;
  line-height: 80px;
  border-radius: 40px;
  text-align: center;
  font-size: 30px;
  &--pay {
    background: var(--error-color, #ff0000);
    color: #fff;
  }
  &--outline {
    background: #fff;
    color: var(--error-color, #ff0000);
    border: 2px solid var(--error-color, #ff0000);
  }
}

// 卡片 2 头部：No. + Copy
.order-details-info-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.order-details-info-no {
  font-size: 28px;
  font-weight: bold;
  color: #111;
}
.order-details-copy {
  display: flex;
  align-items: center;
  color: var(--theme-color, #ff8800);
  font-weight: bold;
  font-size: 28px;
}
.order-details-copy-icon {
  width: 28px;
  height: 28px;
  margin-right: 6px;
}
.order-details-copy-text {
  // 同 color
}

// 卡片 2 字段行
.order-details-info-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 0;
}
.order-details-info-label {
  color: var(--text-sub, #999);
  font-size: 28px;
}
.order-details-info-value {
  color: #111;
  font-size: 28px;
  font-weight: bold;
  text-align: right;
  max-width: 60%;
  word-break: break-all;
}
</style>
